<template>
  <div class="commentBack" @click="$emit('closeComment')">
    <div class="comment" @click.stop>
        <div class="comment__top">
            <h2>Оставьте свой комментарий!</h2>
        </div>
        <div class="comment__bot">
            <textarea v-model="comment" placeholder="Ваш комментарий"></textarea>
            <button class="comment__bot__send" @click="$emit('sendComment', comment, confirm)">Отправить</button>
        </div>
    </div>
  </div>
</template>

<script  setup>
import { ref } from 'vue';

const comment = ref('')
const emit = defineEmits(['sendComment', 'closeComment']);
const props = defineProps(['confirm'])
</script>

<style lang="scss" scoped>
.commentBack {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}
.comment {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    &__top {
        margin-bottom: 20px;
        h2 {
            margin: 0;
            font-size: 1.5em;
            color: #333;
        }
    }
    &__bot {
        display: flex;
        flex-direction: column;
        textarea {
            width: 100%;
            height: 100px;
            padding: 10px;
            border-radius: 4px;
            border: 1px solid #ccc;
            resize: none;
            margin-bottom: 10px;
        }
        .comment__bot__send {
            align-self: flex-end;
            padding: 10px 20px;
            background-color: #007bff;
            color: #fff;
            border: none;
            border-radius: 4px;
            cursor: pointer;
        }
    }
}
</style>